export default function ChevronLeftIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="34" height="34" fill="transparent" />
      <path d="M20 24.5L12.5 17L20 9.5" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}
